define((require, exports, module) => {
    'use strict';

    const xPageId = require('xPageId');

    let i = 0;

    /**
     * @returns {string}
     */
    function uid() {
        return xPageId + '-' + Date.now().toString(36) + '-' + i++;
    }

    module.exports = uid;
});
